"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _react = _interopRequireDefault(require("react"));
require("../styles/ProvisioningDeviceComponent.css");
var _SearchWithSort = require("@ccw-pwa-ui/SearchWithSort");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _Button = require("@ccw-pwa-ui/Button");
var _images = _interopRequireWildcard(require("../common_features/assets/images"));
var _Modal = require("@ccw-pwa-ui/Modal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import SearchWithSort from "./SearchWithSort";
// import { Spinner } from "react-bootstrap";
// import SearchWithSort from "./addSystem/common/SearchWithSort";

const ProvisioningDeviceComponent = _ref => {
  let {
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    subContent,
    continueBtnDisabled,
    continueBtnTitle,
    pageMainContent,
    pageSubContent,
    guidedBtnDisabled,
    guidedBtnTitle,
    onContinueBtnClick,
    onchange,
    value,
    id,
    partList,
    provisioningGuidedBtn,
    listEnable,
    defaultSystem,
    backNavigate,
    warningSystemModalData,
    productImage
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "provisioning-detail-wrapper",
    "data-testid": "addSystemList"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _images.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "provisioning-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "provisioning-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "provisioning-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "provisioning-subContent"
  }, /*#__PURE__*/_react.default.createElement("p", null, subContent)), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "provising-device-select"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "part-input-label"
  }, "Part # or Model #"), /*#__PURE__*/_react.default.createElement(_SearchWithSort.SearchWithSort, {
    className: "provising-device-select",
    onchange: onchange,
    partList: partList,
    id: id,
    listEnable: listEnable,
    defaultSystem: defaultSystem
  })), continueBtnDisabled ? '' : /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(productImage ? "product-found-centerImg" : "product-notfound-centerImg"),
    style: {
      marginBottom: "200px"
    }
  }, productImage ? /*#__PURE__*/_react.default.createElement("img", {
    src: productImage,
    alt: "device"
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: _images.noImg.default,
    alt: "No product image"
  }), !productImage ? /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginTop: "10px"
    }
  }, "No product image to show") : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "provisioning-continue-btn-div",
    "data-testid": "provisioning-continue-btn-div"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: continueBtnTitle,
    onClick: onContinueBtnClick,
    disabled: continueBtnDisabled
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom-content-wrapper"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "page-main-content"
  }, pageMainContent), /*#__PURE__*/_react.default.createElement("p", {
    className: "page-sub-content"
  }, pageSubContent)))), backNavigate && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.displayModal,
    modalHeaderText: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderText,
    modalHeaderTextStyle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderTextStyle,
    modalDetailText: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalDetailText,
    modalHeaderIcon: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.modalHeaderIcon,
    displayCrossIcon: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.displayCrossIcon,
    variant: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.variant,
    positiveActionButtonTitle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.positiveActionButtonTitle,
    positiveAction: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.positiveAction,
    negativeButtonActionTitle: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.negativeButtonActionTitle,
    crossIconAction: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.crossIconAction,
    negativeAvtion: warningSystemModalData === null || warningSystemModalData === void 0 ? void 0 : warningSystemModalData.negativeAction
  }));
};
var _default = exports.default = ProvisioningDeviceComponent;